import { QP_CALENDAR_VIEW_MODE } from '@/constants/queryParams';
import { useSearchParams } from '@/hooks/useSearchParams';

export function useCalendarDetailsController() {
	const params = useSearchParams();
	const viewMode = params.get(QP_CALENDAR_VIEW_MODE);

	return { viewMode };
}
